import Main from "@/views/Main.vue";
const customerRoutes = [
  {
    path: "/crm",
    icon: "android-menu",
    title: "商家CRM",
    name: 'crm',
    component: Main,
    children: [
      {
        path: "edittechnology",
        title: "编辑技术信息",
        name: 'crmedittechnology',
        component: resolve => {
          require(["@/views/crm/technology.vue"], resolve);
        }
      },
      {
        path: "list",
        title: "Merchant Profile",
        name: 'crmList',
        component: resolve => {
          require(["@/views/crm/index.vue"], resolve);
        }
      },
      {
        path: "edit/:id",
        title: "Merchant Profile",
        name: 'crmEdit',
        component: resolve => {
          require(["@/views/crm/edit.vue"], resolve);
        }
      },
      {
        path: "edit/:id/:re",
        title: "Merchant Profile",
        name: 'crmEditAgain',
        component: resolve => {
          require(["@/views/crm/edit.vue"], resolve);
        }
      },
      {
        path: "audit/:id",
        title: "Merchant Profile",
        name: 'crmAudit',
        component: resolve => {
          require(["@/views/crm/audit.vue"], resolve);
        }
      },
      {
        path: "init",
        title: "Merchant Profile",
        name: 'crmAuditInit',
        component: resolve => {
          require(["@/views/crm/init.vue"], resolve);
        },
      },
      {
        path: "create",
        title: "申请创建新店",
        name: 'crmCreate',
        component: resolve => {
          require(["@/views/crm/form.vue"], resolve);
        }
      },
      {
        path: "store/audit/:id",
        title: "审核建店信息",
        name: 'crmStoreAudit',
        component: resolve => {
          require(["@/views/crm/form.vue"], resolve);
        }
      },
      {
        path: "store/edit/:id",
        title: "重新申请建店",
        name: 'crmStoreEdit',
        component: resolve => {
          require(["@/views/crm/form.vue"], resolve);
        }
      },
      {
        path: "store/show/:id",
        title: "查看商家信息",
        name: 'crmStoreShow',
        component: resolve => {
          require(["@/views/crm/form.vue"], resolve);
        }
      },
      {
        path: "aftersale/:id",
        title: "售后履约信息维护",
        name: 'crmAfterSale',
        component: resolve => {
          require(["@/views/crm/aftersale.vue"], resolve);
        }
      },
      {
        path: "api",
        title: "商家接口地址",
        name: 'APIConfig',
        component: resolve => {
          require(["@/views/crm/api.vue"], resolve);
        }
      },

      // ── CN 路由（直接作为 /crm 的子路由，不加中间层 Main）──
      { path: "cn/edittechnology", title: "编辑技术信息(CN)", name: 'crmCnEdittechnology', component: r => require(["@/views/crm/cn/technology.vue"], r) },
      { path: "cn/list", title: "Merchant Profile(CN)", name: 'crmCnList', component: r => require(["@/views/crm/cn/index.vue"], r) },
      { path: "cn/edit/:id", title: "Merchant Profile(CN)", name: 'crmCnEdit', component: r => require(["@/views/crm/cn/edit.vue"], r) },
      { path: "cn/edit/:id/:re", title: "Merchant Profile(CN)", name: 'crmCnEditAgain', component: r => require(["@/views/crm/cn/edit.vue"], r) },
      { path: "cn/audit/:id", title: "Merchant Profile(CN)", name: 'crmCnAudit', component: r => require(["@/views/crm/cn/audit.vue"], r) },
      { path: "cn/init", title: "Merchant Profile(CN)", name: 'crmCnAuditInit', component: r => require(["@/views/crm/cn/init.vue"], r) },
      { path: "cn/create", title: "申请创建新店(CN)", name: 'crmCnCreate', component: r => require(["@/views/crm/cn/form.vue"], r) },
      { path: "cn/store/audit/:id", title: "审核建店信息(CN)", name: 'crmCnStoreAudit', component: r => require(["@/views/crm/cn/form.vue"], r) },
      { path: "cn/store/edit/:id", title: "重新申请建店(CN)", name: 'crmCnStoreEdit', component: r => require(["@/views/crm/cn/form.vue"], r) },
      { path: "cn/store/show/:id", title: "查看商家信息(CN)", name: 'crmCnStoreShow', component: r => require(["@/views/crm/cn/form.vue"], r) },
      { path: "cn/aftersale/:id", title: "售后履约信息维护(CN)", name: 'crmCnAfterSale', component: r => require(["@/views/crm/cn/aftersale.vue"], r) },
      { path: "cn/api", title: "商家接口地址(CN)", name: 'crmCnAPIConfig', component: r => require(["@/views/crm/cn/api.vue"], r) },
      { path: "cn/performance/configure", title: "买手店履约配置(CN)", name: 'crmCnPerformanceConfigure', component: r => require(["@/views/crm/cn/performance/configure.vue"], r) },
      { path: "cn/:id", title: "Merchant Profile(CN)", name: 'crmCnDetail', component: r => require(["@/views/crm/cn/detail.vue"], r) },

      {
        path: ":id",
        title: "Merchant Profile",
        name: 'crmDetail',
        component: resolve => {
          require(["@/views/crm/detail.vue"], resolve);
        }
      },
      {
        path: "performance/configure",
        title: "买手店履约配置",
        name: 'performanceConfigure',
        component: resolve => {
          require(["@/views/crm/performance/configure.vue"], resolve);
        }
      },
    ]
  }
]

export default customerRoutes
